import { makeStyles } from '@material-ui/core';

const useEvReportStyles = makeStyles((theme) => ({
    container: {
        height: 'calc(100vh - 90px)',
        overflow: 'auto',
        paddingBottom: '0px',
    },
    headerBox: {
        padding: '20px 24px 0 24px',
    },
    pageTitle: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#14112D',
    },
    pageSubTitle: {
        fontSize: '0.875rem',
        fontWeight: 400,
        color: 'rgba(20, 17, 45, 0.60)',
        marginTop: 2,
    },
    filtersRow: {
        padding: '16px 24px',
        borderBottom: '1px solid #EBEDF8',
        backgroundColor: '#fff',
    },
    datePickerWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    dateSeparator: {
        fontSize: '0.875rem',
        color: 'rgba(20, 17, 45, 0.50)',
        fontWeight: 500,
    },
    searchWrapper: {
        flex: 1,
        maxWidth: 320,
    },
    tableSection: {
        padding: '0 24px 0 24px',
    },
    tableContainer: {
        width: '100%',
        overflowY: 'auto',
        overflowX: 'auto',
        minHeight: 'calc(100vh - 320px)',
        maxHeight: 'calc(100vh - 320px)',
        '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#D0D5E8',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#9BA8D0',
        },
    },
    tableHeadCell: {
        fontWeight: 700,
        fontSize: 13,
        color: '#525050',
        backgroundColor: '#F6F7F9',
        padding: '10px 16px',
        borderBottom: '1px solid #EBEDF8',
        whiteSpace: 'nowrap',
    },
    tableBodyCell: {
        fontSize: 14,
        fontWeight: 500,
        color: '#14112D',
        padding: '10px 16px',
        borderBottom: '1px solid #EBEDF8',
        whiteSpace: 'nowrap',
    },
    tableValue: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#14112D',
        lineHeight: '20px',
    },
    tableSubValue: {
        fontSize: '13px',
        fontWeight: 400,
        color: 'rgba(20, 17, 45, 0.60)',
        marginTop: 2,
    },
    vinChip: {
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: '#F0F1FF',
        color: '#43419E',
        borderRadius: 6,
        padding: '2px 8px',
        fontSize: 13,
        fontWeight: 600,
    },
    metricValue: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#14112D',
    },
    metricUnit: {
        fontSize: '12px',
        fontWeight: 400,
        color: 'rgba(20, 17, 45, 0.50)',
        marginLeft: 3,
    },
    noDataBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        color: 'rgba(20, 17, 45, 0.40)',
    },
    noDataText: {
        fontSize: '1rem',
        fontWeight: 500,
        marginTop: 16,
        color: 'rgba(20, 17, 45, 0.50)',
    },
    applyCTA: {
        backgroundColor: '#14112D',
        color: '#fff',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 20px',
        textTransform: 'none',
        minWidth: 100,
        '&:hover': {
            backgroundColor: '#14112D',
            opacity: 0.88,
        },
    },
    resetCTA: {
        color: '#14112D',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 16px',
        textTransform: 'none',
        border: '1px solid #EBEDF8',
    },
    dateInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            fontSize: 14,
            backgroundColor: '#fff',
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 14px',
        },
        '& .MuiInputLabel-outlined': {
            fontSize: 13,
        },
    },
    summaryCard: {
        backgroundColor: '#F6F7F9',
        borderRadius: 8,
        padding: '12px 20px',
        border: '1px solid #EBEDF8',
        minWidth: 140,
    },
    summaryCardValue: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#14112D',
    },
    summaryCardLabel: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: 'rgba(20, 17, 45, 0.60)',
        marginTop: 2,
    },
}));

export default useEvReportStyles;
